// Route page for the Order Management → "Create New Order" nav item. The nav
// item navigates (CollapsibleDashboard submenu items have no onClick support),
// so this tiny page exists purely to open the flow: it fires `openCreateOrder`
// on mount and otherwise renders a minimal placeholder with a button to
// re-open the modal if the user dismissed it. Never redirects away — closing
// the modal without creating anything should just leave the user here.
import React, { useEffect } from 'react';
import { useCreateOrderFlow } from './CreateOrderFlowContext';

const CreateOrderLauncher: React.FC = () => {
  const { openCreateOrder } = useCreateOrderFlow();

  useEffect(() => {
    openCreateOrder();
    // Fire once on mount only — openCreateOrder is stable, but this must NOT
    // re-open every time the flow's identity happens to change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 p-8 text-center">
      <h1 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Create New Order</h1>
      <p className="text-sm text-slate-500 dark:text-slate-400 max-w-md">
        The Create New Order dialog opens automatically. If you dismissed it, reopen it below.
      </p>
      <button
        type="button"
        onClick={openCreateOrder}
        className="px-4 py-2 text-[0.8125rem] font-semibold text-white bg-blue-600 border border-blue-700 rounded-md hover:bg-blue-700"
      >
        + Create New Order
      </button>
    </div>
  );
};

export default CreateOrderLauncher;
